import type { KeywordDefinition } from 'ajv'

/**
 * Test-only async AJV keyword that demonstrates async validation.
 * Returns a promise that resolves after a delay.
 * 
 * Usage in schema:
 * {
 *   "type": "string",
 *   "asyncTest": true
 * }
 */
export const asyncTest: KeywordDefinition = {
  keyword: 'asyncTest',
  type: 'string',
  schemaType: 'boolean',
  async: true,
  errors: true,
  validate: async function validateAsyncTest(
    schema: boolean,
    data: string
  ): Promise<boolean> {
    if (!schema) return true // keyword disabled
    
    // Simulate async operation (e.g., API call)
    await new Promise(resolve => setTimeout(resolve, 500))
    
    // Validation logic: fail if string contains "invalid"
    if (data && data.toLowerCase().includes('invalid')) {
      ;(validateAsyncTest as any).errors = [
        {
          keyword: 'asyncTest',
          message: 'Value must not contain "invalid"',
          params: {},
        },
      ]
      return false
    }
    
    return true
  },
}
